<template>
  <div>
    <Head :title="`${permission.name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-2xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/permissions">Permission</Link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ permission.name }}
      </h1>
    </div>
    <div class="w-full bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nama Permission" maxlength="255" />
          <text-input v-model="form.guard_name" :error="form.errors.guard_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Guard Name" maxlength="255" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            <font-awesome-icon icon="fas fa-floppy-disk" class="mr-2" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    permission: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.permission.name,
        guard_name: this.permission.guard_name,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/permissions/${this.permission.id}`)
    },
  },
}
</script>
